import IntegrationsView from './IntegrationsView';

export default IntegrationsView;
